import { useMutation, useQueryClient } from "@tanstack/react-query";
import { login } from "@/api/auth";
import { LoginParams, LoginResponse } from "@/types/auth";

interface UseLoginOptions {
  onSuccess?: (data: LoginResponse) => void;
  onError?: (error: unknown) => void;
}

export function useLogin(options?: UseLoginOptions) {
  const queryClient = useQueryClient();

  return useMutation<LoginResponse, unknown, LoginParams>({
    mutationFn: login,
    onSuccess: (data) => {
      queryClient.setQueryData(["auth", "user"], data);
      localStorage.setItem("user", JSON.stringify(data));
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
}
